import { TFilterItem } from '../../pages/Trader/OrdersAndWithdrawals/components/Filter/types';

export const ordersFilters: TFilterItem[] = [
  {
    filterId: '',
    filterText: 'Все',
  },
  {
    filterId: 'BN',
    filterText: 'Новые заявки',
  },
  {
    filterId: 'SF',
    filterText: 'Завершена успешно',
  },
  {
    filterId: 'AA',
    filterText: 'Автоматически одобрена',
  },
  {
    filterId: 'CANCELED',
    filterText: 'Отклонена',
  },
  {
    filterId: 'ID',
    filterText: 'Спор',
  },
  {
    filterId: 'FR',
    filterText: 'Завершенные с перерасчетом',
  },
  {
    filterId: 'UR',
    filterText: 'Заявка с перерасчетом',
  },
  {
    filterId: 'TO',
    filterText: 'Просроченные',
  },
  {
    filterId: 'IP',
    filterText: 'В процессе',
  },
  {
    filterId: 'CR',
    filterText: 'Перерасчет отклонен',
  },
  {
    filterId: 'AAD',
    filterText: 'Автоматически одобрена из диспута',
  },
];
export const withdrawalsFilters: TFilterItem[] = [
  {
    filterId: '',
    filterText: 'Все',
  },
  {
    filterId: 'BN',
    filterText: 'Новая заявка',
  },
  {
    filterId: 'IP',
    filterText: 'В процессе',
  },
  {
    filterId: 'SF',
    filterText: 'Завершена успешно',
  },
  {
    filterId: 'PC',
    filterText: 'Проблема подтверждена',
  },
  {
    filterId: 'STS',
    filterText: 'Отправлена в поддержку',
  },
  {
    filterId: 'ID',
    filterText: 'Спор',
  },
  {
    filterId: 'STSD',
    filterText: 'Спор отправлен в поддержку',
  },
  {
    filterId: 'CR',
    filterText: 'Перерасчет отклонен',
  },
  {
    filterId: 'FR',
    filterText: 'Завершена с перерасчетом',
  },
];
